import { DomHelper } from '../modules/DomHelper';

/**
 * NewsPage — お知らせ一覧ページ固有の初期化
 * body[data-page="news"] のときのみ実行される
 *
 * カテゴリーフィルター:
 *   - .js-filter-btn[data-filter="all|news|column|..."] のクリックを監視
 *   - .js-news-item[data-category="..."] を data-hidden 属性で表示/非表示切り替え
 *   - aria-pressed / aria-live で支援技術に変化を伝える
 *
 * WordPress 移植時:
 *   - Ajax/fetch で WP_Query を叩いてDOM入れ替えに変更
 *   - または Isotope / Masonry のフィルタリングに差し替え
 */
export class NewsPage {
  private currentFilter = 'all';

  init(): void {
    this.initCategoryFilter();
  }

  private initCategoryFilter(): void {
    const filterBtns = DomHelper.qsa<HTMLButtonElement>('.js-filter-btn');
    const newsItems = DomHelper.qsa<HTMLElement>('.js-news-item');

    if (filterBtns.length === 0 || newsItems.length === 0) return;

    filterBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const filter = btn.dataset.filter ?? 'all';
        if (filter === this.currentFilter) return;

        this.currentFilter = filter;

        // ボタン状態更新
        filterBtns.forEach((b) => {
          const isActive = b === btn;
          DomHelper.toggleClass(b, 'is-active', isActive);
          b.setAttribute('aria-pressed', String(isActive));
        });

        // アイテムの表示切り替え
        let visibleCount = 0;
        newsItems.forEach((item) => {
          const category = item.dataset.category ?? '';
          const isVisible = filter === 'all' || category === filter;

          if (isVisible) {
            item.dataset.hidden = undefined;
            item.removeAttribute('data-hidden');
            visibleCount++;
          } else {
            item.dataset.hidden = '';
          }
        });

        // GTM データ層に送信
        DomHelper.pushDataLayer({
          event: 'news_filter',
          filter_category: filter,
          visible_count: visibleCount,
        });
      });
    });
  }
}
